export default __webpack_public_path__ + "media/images/temporary/how-we-plant-1952f54d05314560a3b3ee692ac0cd5e.jpg";